export default "__VITE_ASSET__Cp89GahU__"